// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__9Cs67","icon":"SortAdornment_icon__2DKi6","up":"SortAdornment_up__By8KQ","down":"SortAdornment_down__Qiw_N","active":"SortAdornment_active__3Boss"};